import { NewsModel } from "@/models";
import { newsPolicy } from "@/policies";
import { auth } from "@/services";

// TODO: this directive should not be responsible for managing multiple news article... 🤷‍♂️
(function (angular) {
  "use strict";

  angular.module("app").directive("news", news);

  news.$inject = [
    "News",
    "NewsApi",
    "$rootScope",
    "handleError",
    "thisSiteSettings",
  ];

  function news(News, NewsApi, $rootScope, handleError, thisSiteSettings) {
    function newsLink($scope, el, attr) {
      // properties
      $scope.isLoading = false;
      $scope.page = $scope.page || 1;
      $scope.thisUser = $rootScope.thisUser;
      $scope.thisSiteSettings = thisSiteSettings;

      // methods
      $scope.editNews = editNews;
      $scope.getNews = getNews;

      $scope.itemType = "news";

      /**
       * Initialised the directive.
       *
       * @returns {void}
       */
      function bootstrap(): void {
        // Load news from the API?
        if (!$scope.news || !$scope.news.length) {
          $scope.isLoading = true;

          const params: Record<string, any> = {
            page: $scope.page,
          };

          if (attr.user) {
            params.user_id = attr.user;
          }

          getNews();
        }
      }

      /**
       * Performs any motifications to the data that we require.
       * This is necessary because this directive manages an array of news articles.
       *
       * @returns {void}
       */
      function transformData(): void {
        const user = auth.user();

        $scope.news.forEach((item) => {
          const model = new NewsModel(item);

          item.createdAtFormatted = window
            .moment(item.created_at)
            .format("dddd Do MMMM Y");
          item.policyChecks = {
            canManage: newsPolicy.canManage(user, model),
          };
        });
      }

      transformData();

      /**
       * Edits the news via a modal, and updates model
       * @param  {int} newsId - ID of news to edit
       * @return {void}
       */
      function editNews(newsId) {
        News.manageNews(newsId).result.then(
          function (updatedNews) {
            // Find and update the news
            angular.forEach($scope.news, function (news, index) {
              if (news.id === updatedNews.id) {
                if (updatedNews.deleted) {
                  getNews();
                } else {
                  $scope.news[index] = updatedNews;
                }
              }
            });
          },
          function (err) {
            handleError(err);
          },
        );
      }

      function getNews() {
        NewsApi.get(
          {},
          function (response) {
            $scope.isLoading = false;
            $scope.news = response.data;
            transformData();
          },
          function (err) {
            $scope.isLoading = false;
          },
        );
      }

      bootstrap();
    }

    return {
      restrict: "E",
      templateUrl: "directives/news.html",
      link: newsLink,
      scope: {
        news: "=", // (optional) {Array} news objects
        showControls: "=", // (optional) {Bool} set to false to hide pagination and other controls
        page: "=?", // (optional) {Int} initial page no.
      },
    };
  }
})(angular);
